<h3>Buscar Agente Público</h3>
<a href="#" class="sr-only">Buscar Agente Público</a>
<div class="row">
    <div class="col-sm-12">
        <div class="br-card bg-gray-5">
            <form [formGroup]="formFiltro">
                <div class="card-content">
                    <div class="row" *ngIf="!emProcessoDeLimpeza">
                        <div class="col-12 col-lg-4 mt-2 br-input">
                            <label for="campo-orgao">Órgão</label>
                            <frq-select-orgao id="campo-orgao" [required]="false" [style]="{ width: '100%' }" (changeCallback)="onChangeOrgao()"></frq-select-orgao>
                        </div>
                        <div class="col-12 col-lg-4 mt-2 br-input">
                            <label for="campo-upag">UPAG</label>
                            <frq-select-upag id="campo-upag" [required]="false" [idOrgao]="formFiltro.controls.codigoOrgao.value" (opcoesCarregadas)="onOpcoesUpagCarregadas($event)"></frq-select-upag>
                        </div>
                        <div class="col-12 col-lg-4 mt-2 br-input">
                            <label for="campo-uorg">UORG{{ obrigatoriedadeUorgPorNivelAcesso ? " (Obrigatório)" : "" }}</label>
                            <frq-select-uorg id="campo-uorg" [required]="selecaoUorgObrigatoria ? true : false" [idOrgao]="formFiltro.controls.codigoOrgao.value" [idUpag]="formFiltro.controls.codigoUpag.value"></frq-select-uorg>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-3 mt-2 br-input" [ngClass]="{ danger: formFiltro.controls['cpf'].invalid }">
                            <label for="campo-cpf">CPF</label>
                            <input id="campo-cpf" pInputText frqValidCpf mask="000.000.000-00" maxlength="14" formControlName="cpf" (input)="atualizarObrigatoriedadeSelecaoUorg()" />
                            <p class="mt-1" *ngIf="formFiltro.controls['cpf'].errors?.['invalidCpf'] && submetido">
                                <span class="feedback danger" role="alert">
                                    <i class="fas fa-times-circle" aria-hidden="true"></i>
                                    CPF inválido
                                </span>
                            </p>
                        </div>
                        <div class="col-12 col-lg-9 mt-2 br-input">
                            <label for="campo-nome">Nome</label>
                            <input id="campo-nome" pInputText name="nome" formControlName="nome" minlength="1" (input)="atualizarObrigatoriedadeSelecaoUorg()" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-3 mt-2 br-input">
                            <label for="campo-situacao-vinculo">Situação Para Efeito de Férias (Obrigatório)</label>
                            <p-multiSelect id="campo-situacao-vinculo" formControlName="situacoesEfeitoFeriasSelecionadas" [options]="situacoesEfeitoFerias" optionLabel="descricao" styleClass="mt-1" [filter]="false" [required]="true" [overlayOptions]="{ appendTo: 'body' }" (onChange)="atualizarObrigatoriedadeSelecaoUorg()">
                                <ng-template pTemplate="filtericon">
                                    <span class="fas fa-search"></span>
                                </ng-template>
                                <ng-template pTemplate="checkicon">
                                    <span class="fas fa-check"></span>
                                </ng-template>
                                <ng-template pTemplate="dropdownicon">
                                    <span class="fas fa-chevron-down"></span>
                                </ng-template>
                            </p-multiSelect>
                            <p class="mt-1" *ngIf="formFiltro.controls['situacoesEfeitoFeriasSelecionadas'].errors?.['required'] && submetido">
                                <span class="feedback danger" role="alert">
                                    <i class="fas fa-times-circle" aria-hidden="true"></i>
                                    Campo obrigatório
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row mt-2">
                        <span class="fas fa-info-circle" style="padding-left: 50px; padding-top: 3px; margin-right: 25px"></span>
                        O resultado desta busca apresenta apenas os dados dos órgãos incluídos na primeira fase de implantação do SIGEPE Férias.
                        <div class="col text-right">
                            <button aria-label="botão limpar" id="botao-limpar" pButton type="button" label="Limpar" data-cy="botao-limpar" class="mr-2" (click)="limpar()"></button>
                            <button aria-label="botão pesquisar" id="botao-pesquisar" pButton type="submit" label="Pesquisar" data-cy="botao-pesquisar" class="primary" (click)="pesquisar()"></button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="my-2 text-semi-bold" *ngIf="resultadoPesquisa && resultadoPesquisa.length > 0">
    Total de Registros Encontrados: {{ resultadoPesquisa.length }}
    {{ resultadoPesquisa.length >= 100 ? "(retorno parcial)" : "" }}
</div>
<div class="row br-table" *ngIf="resultadoPesquisa && resultadoPesquisa.length > 0">
    <div class="col">
        <p-table #pTableResultado [value]="resultadoPesquisa" [autoLayout]="true" [paginator]="true" [rows]="tamanhoPagina" [rowsPerPageOptions]="[10, 25, 50, 100]" responsiveLayout="stack" sortField="nome" paginatorStyleClass="force-up">
            <ng-template pTemplate="header">
                <tr>
                    <th id="cabecalho-nome" pSortableColumn="nome">
                        Nome
                        <p-sortIcon field="nome"></p-sortIcon>
                        <p-columnFilter type="text" field="nome" matchMode="contains" [showClearButton]="false" (click)="$event.stopPropagation()">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <div class="br-input">
                                    <input pInputText [ngModel]="value" (keydown)="$event.stopPropagation()" (keyup)="filterOnInputBlankOrEnter(filter, $event)" (change)="filterOnInputChange(filter, $event)" style="margin-top: 0px !important" />
                                </div>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <th id="cabecalho-cpf" pSortableColumn="cpfFormatado" style="width: 225px">
                        CPF
                        <p-sortIcon field="cpfFormatado"></p-sortIcon>
                        <p-columnFilter type="text" field="cpfFormatado" [showClearButton]="false" (click)="$event.stopPropagation()">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <div class="br-input">
                                    <input pInputText mask="000.000.000-00" maxlength="14" [ngModel]="value" (keydown)="$event.stopPropagation()" (keyup)="filterOnInputBlankOrEnter(filter, $event)" (change)="filterOnInputChange(filter, $event)" style="margin-top: 0px !important" />
                                </div>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <th id="cabecalho-orgaoupaguorg" pSortableColumn="descricaoOrgaoUpagUorg">
                        Órgão/UPAG/UORG
                        <p-sortIcon field="descricaoOrgaoUpagUorg"></p-sortIcon>
                        <p-columnFilter type="text" field="descricaoOrgaoUpagUorg" matchMode="contains" [showClearButton]="false" (click)="$event.stopPropagation()">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <div class="br-input">
                                    <input pInputText [ngModel]="value" (keydown)="$event.stopPropagation()" (keyup)="filterOnInputBlankOrEnter(filter, $event)" (change)="filterOnInputChange(filter, $event)" style="margin-top: 0px !important" />
                                </div>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <th id="cabecalho-matriculacargo" pSortableColumn="descricaoCargo">
                        Matrícula/Cargo
                        <p-sortIcon field="descricaoCargo"></p-sortIcon>
                        <p-columnFilter type="text" field="descricaoMatriculaCargo" matchMode="contains" [showClearButton]="false" (click)="$event.stopPropagation()">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <div class="br-input">
                                    <input pInputText [ngModel]="value" (keydown)="$event.stopPropagation()" (keyup)="filterOnInputBlankOrEnter(filter, $event)" (change)="filterOnInputChange(filter, $event)" style="margin-top: 0px !important" />
                                </div>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <th id="cabecalho-situacao-funcional" pSortableColumn="descricaoSituacaoFuncional">
                        Situação Funcional
                        <p-sortIcon field="descricaoSituacaoFuncional"></p-sortIcon>
                        <p-columnFilter type="text" field="descricaoCodigoSituacaoFuncional" matchMode="contains" [showClearButton]="false" (click)="$event.stopPropagation()">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <div class="br-input">
                                    <input pInputText [ngModel]="value" (keydown)="$event.stopPropagation()" (keyup)="filterOnInputBlankOrEnter(filter, $event)" (change)="filterOnInputChange(filter, $event)" style="margin-top: 0px !important" />
                                </div>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <th id="cabecalho-situacao-vinculo" pSortableColumn="descricaoSituacaoVinculo" style="width: 180px">
                        Situação do Vínculo
                        <p-sortIcon field="descricaoSituacaoVinculo"></p-sortIcon>
                        <p-columnFilter field="descricaoSituacaoVinculo" matchMode="equals" [showMenu]="false" (click)="$event.stopPropagation()">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-dropdown [options]="['Ativo', 'Encerrado']" [ngModel]="value" (keydown)="$event.stopPropagation()" (onChange)="filter($event.value)" [removeClearButton]="true" styleClass="mb-1" [overlayOptions]="{ appendTo: 'body' }">
                                    <ng-template pTemplate="dropdownicon">
                                        <span class="fas fa-chevron-down"></span>
                                    </ng-template>
                                </p-dropdown>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <th id="cabecalho-acoes" class="text-center" style="width: 95px">Ação</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-registro>
                <tr>
                    <td headers="cabecalho-nome">
                        <p class="m-0 text-weight-medium">
                            <span class="p-column-title">
                                Nome
                                <br />
                            </span>
                            {{ registro.nome }}
                        </p>
                    </td>
                    <td headers="cabecalho-cpf">
                        <p class="m-0 text-weight-medium">
                            <span class="p-column-title">
                                CPF
                                <br />
                            </span>
                            {{ registro.cpfFormatado }}
                        </p>
                    </td>
                    <td headers="cabecalho-orgaoupaguorg">
                        <p class="m-0 text-weight-medium">
                            <span class="p-column-title">
                                Órgão/UPAG/UORG
                                <br />
                            </span>
                            {{ registro.descricaoOrgaoUpagUorg }}
                        </p>
                    </td>
                    <td headers="cabecalho-matriculacargo">
                        <p class="m-0 text-weight-medium">
                            <span class="p-column-title">
                                Matrícula/Cargo
                                <br />
                            </span>
                            {{ registro.descricaoMatriculaCargo }}
                        </p>
                    </td>
                    <td headers="cabecalho-situacao">
                        <p class="m-0 text-weight-medium">
                            <span class="p-column-title">
                                Situação Funcional
                                <br />
                            </span>
                            {{ registro.descricaoCodigoSituacaoFuncional }}
                        </p>
                    </td>
                    <td headers="cabecalho-situacao">
                        <p class="m-0 text-weight-medium">
                            <span class="p-column-title">
                                Situação do Vínculo
                                <br />
                            </span>
                            {{ registro.descricaoSituacaoVinculo }}
                        </p>
                    </td>
                    <td class="coluna-acao" headers="cabecalho-acoes" class="text-center">
                        <p-button class="p-element" styleClass="m-2 circle" icon="fas fa-eye" (click)="ver(registro)" title="Visualizar"></p-button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
<sgp-nenhum-resultado *ngIf="(!resultadoPesquisa || resultadoPesquisa.length == 0) && pesquisaRealizada" data-cy="nenhum-resultado"></sgp-nenhum-resultado>
